import { render } from "./TestQuestion.vue?vue&type=template&id=1c9612b1&scoped=true&ts=true"
import script from "./TestQuestion.vue?vue&type=script&lang=ts"
export * from "./TestQuestion.vue?vue&type=script&lang=ts"

import "./TestQuestion.vue?vue&type=style&index=0&id=1c9612b1&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9612b1"]])

export default __exports__